"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethods = void 0;
const gearbox_1 = require("@busy-human/gearbox");
var PaymentMethods;
(function (PaymentMethods) {
    function Default() {
        return {
            paymentMethodId: null,
            stripeExternalAccountId: null,
            nickname: "",
            type: "credit",
            forPayouts: false
        };
    }
    PaymentMethods.Default = Default;
    class CollectionClass extends gearbox_1.CollectionEntity {
        defaults() {
            return Default();
        }
    }
    PaymentMethods.CollectionClass = CollectionClass;
    PaymentMethods.SubPath = "PaymentMethods";
})(PaymentMethods = exports.PaymentMethods || (exports.PaymentMethods = {}));
//# sourceMappingURL=index.js.map